import type { ChildUse } from '~/lib/graphql/graphql'

/**
 * チャージの発生するテーブル数を計算する
 */
export const calcTableCount = (visitorsCount: number, capacity: number) => {
  return Math.ceil(visitorsCount / capacity)
}

/**
 * お子様が小学生以下かどうか
 * 未就学児と小学生をお子様として扱う
 */
export function isUpToGradeSchooler(childUse: ChildUse) {
  return childUse === 'PRE_SCHOOLERS' || childUse === 'GRADE_SCHOOLERS'
}
if (import.meta.vitest) {
  const { it, expect } = import.meta.vitest
  it('disabledChildUse', () => {
    expect(isUpToGradeSchooler('OVER_MIDDLE_SCHOOLERS')).toBe(false)
    expect(isUpToGradeSchooler('PRE_SCHOOLERS')).toBe(true)
    expect(isUpToGradeSchooler('GRADE_SCHOOLERS')).toBe(true)
  })
}
